import { default as _91_46_46_46cms_93NnQHVoLJgHMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/[...cms].vue?macro=true";
import { default as _91_46_46_46slug_93kRFjMuDjeHMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/3d-projects/[...slug].vue?macro=true";
import { default as indexziUzg2rQxFMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/3d-projects/index.vue?macro=true";
import { default as _91_46_46_46slug_93cslbKJXcNpMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/akcii/[...slug].vue?macro=true";
import { default as indexjgyYYkJvqaMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/akcii/index.vue?macro=true";
import { default as _91_46_46_46slug_93UpC8PfWAg5Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/articles/[...slug].vue?macro=true";
import { default as indexHCsfNGMeXfMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/articles/index.vue?macro=true";
import { default as indexfD0nqNvMtfMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/authorization/index.vue?macro=true";
import { default as indexgr3sxr3vMvMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/cart/index.vue?macro=true";
import { default as _91_46_46_46id_93XynGDSOQN7Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/cart/success/[...id].vue?macro=true";
import { default as _91_46_46_46slug_93nIpn9Ok7uEMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/catalog/[...slug].vue?macro=true";
import { default as indexWIThtCOO6WMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_938G9TGb2S2fMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/catalogsearch/[...slug].vue?macro=true";
import { default as resultNA0lFB7e3MMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/catalogsearch/result.vue?macro=true";
import { default as indexaf04FAVyZHMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/clear-page-slider/index.vue?macro=true";
import { default as _91_46_46_46slug_93oFX1B3dqhfMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/collection/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_930BL4GZu2eTMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/fabriki/[...slug].vue?macro=true";
import { default as indexRPbLw8m6D3Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/fabriki/index.vue?macro=true";
import { default as _91hash_93sEyZ0eTGLLMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/order-status/[hash].vue?macro=true";
import { default as _91_46_46_46slug_93d8UUGL1KoeMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/product/[...slug].vue?macro=true";
import { default as indexB9CpW7mpixMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/profile/index.vue?macro=true";
import { default as indexcXMe0A11eyMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/profile/orders/index.vue?macro=true";
import { default as indexe6stM6e0hUMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/recently/index.vue?macro=true";
import { default as _91_46_46_46slug_93MyqoL7Ux4JMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/sets/[...slug].vue?macro=true";
import { default as indexqh8e2ecWoVMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46cms_93NnQHVoLJgHMeta?.name ?? "cms",
    path: _91_46_46_46cms_93NnQHVoLJgHMeta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_93NnQHVoLJgHMeta || {},
    alias: _91_46_46_46cms_93NnQHVoLJgHMeta?.alias || [],
    redirect: _91_46_46_46cms_93NnQHVoLJgHMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93kRFjMuDjeHMeta?.name ?? "3d-projects-slug",
    path: _91_46_46_46slug_93kRFjMuDjeHMeta?.path ?? "/3d-projects/:slug(.*)*",
    meta: _91_46_46_46slug_93kRFjMuDjeHMeta || {},
    alias: _91_46_46_46slug_93kRFjMuDjeHMeta?.alias || [],
    redirect: _91_46_46_46slug_93kRFjMuDjeHMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/3d-projects/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexziUzg2rQxFMeta?.name ?? "3d-projects",
    path: indexziUzg2rQxFMeta?.path ?? "/3d-projects",
    meta: indexziUzg2rQxFMeta || {},
    alias: indexziUzg2rQxFMeta?.alias || [],
    redirect: indexziUzg2rQxFMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/3d-projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93cslbKJXcNpMeta?.name ?? "akcii-slug",
    path: _91_46_46_46slug_93cslbKJXcNpMeta?.path ?? "/akcii/:slug(.*)*",
    meta: _91_46_46_46slug_93cslbKJXcNpMeta || {},
    alias: _91_46_46_46slug_93cslbKJXcNpMeta?.alias || [],
    redirect: _91_46_46_46slug_93cslbKJXcNpMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/akcii/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexjgyYYkJvqaMeta?.name ?? "akcii",
    path: indexjgyYYkJvqaMeta?.path ?? "/akcii",
    meta: indexjgyYYkJvqaMeta || {},
    alias: indexjgyYYkJvqaMeta?.alias || [],
    redirect: indexjgyYYkJvqaMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/akcii/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93UpC8PfWAg5Meta?.name ?? "articles-slug",
    path: _91_46_46_46slug_93UpC8PfWAg5Meta?.path ?? "/articles/:slug(.*)*",
    meta: _91_46_46_46slug_93UpC8PfWAg5Meta || {},
    alias: _91_46_46_46slug_93UpC8PfWAg5Meta?.alias || [],
    redirect: _91_46_46_46slug_93UpC8PfWAg5Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/articles/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexHCsfNGMeXfMeta?.name ?? "articles",
    path: indexHCsfNGMeXfMeta?.path ?? "/articles",
    meta: indexHCsfNGMeXfMeta || {},
    alias: indexHCsfNGMeXfMeta?.alias || [],
    redirect: indexHCsfNGMeXfMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/articles/index.vue").then(m => m.default || m)
  },
  {
    name: indexfD0nqNvMtfMeta?.name ?? "authorization",
    path: indexfD0nqNvMtfMeta?.path ?? "/authorization",
    meta: indexfD0nqNvMtfMeta || {},
    alias: indexfD0nqNvMtfMeta?.alias || [],
    redirect: indexfD0nqNvMtfMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/authorization/index.vue").then(m => m.default || m)
  },
  {
    name: indexgr3sxr3vMvMeta?.name ?? "cart",
    path: indexgr3sxr3vMvMeta?.path ?? "/cart",
    meta: indexgr3sxr3vMvMeta || {},
    alias: indexgr3sxr3vMvMeta?.alias || [],
    redirect: indexgr3sxr3vMvMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46id_93XynGDSOQN7Meta?.name ?? "cart-success-id",
    path: _91_46_46_46id_93XynGDSOQN7Meta?.path ?? "/cart/success/:id(.*)*",
    meta: _91_46_46_46id_93XynGDSOQN7Meta || {},
    alias: _91_46_46_46id_93XynGDSOQN7Meta?.alias || [],
    redirect: _91_46_46_46id_93XynGDSOQN7Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/cart/success/[...id].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93nIpn9Ok7uEMeta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93nIpn9Ok7uEMeta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93nIpn9Ok7uEMeta || {},
    alias: _91_46_46_46slug_93nIpn9Ok7uEMeta?.alias || [],
    redirect: _91_46_46_46slug_93nIpn9Ok7uEMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexWIThtCOO6WMeta?.name ?? "catalog",
    path: indexWIThtCOO6WMeta?.path ?? "/catalog",
    meta: indexWIThtCOO6WMeta || {},
    alias: indexWIThtCOO6WMeta?.alias || [],
    redirect: indexWIThtCOO6WMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_938G9TGb2S2fMeta?.name ?? "catalogsearch-slug",
    path: _91_46_46_46slug_938G9TGb2S2fMeta?.path ?? "/catalogsearch/:slug(.*)*",
    meta: _91_46_46_46slug_938G9TGb2S2fMeta || {},
    alias: _91_46_46_46slug_938G9TGb2S2fMeta?.alias || [],
    redirect: _91_46_46_46slug_938G9TGb2S2fMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/catalogsearch/[...slug].vue").then(m => m.default || m)
  },
  {
    name: resultNA0lFB7e3MMeta?.name ?? "catalogsearch-result",
    path: resultNA0lFB7e3MMeta?.path ?? "/catalogsearch/result",
    meta: resultNA0lFB7e3MMeta || {},
    alias: resultNA0lFB7e3MMeta?.alias || [],
    redirect: resultNA0lFB7e3MMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/catalogsearch/result.vue").then(m => m.default || m)
  },
  {
    name: indexaf04FAVyZHMeta?.name ?? "clear-page-slider",
    path: indexaf04FAVyZHMeta?.path ?? "/clear-page-slider",
    meta: indexaf04FAVyZHMeta || {},
    alias: indexaf04FAVyZHMeta?.alias || [],
    redirect: indexaf04FAVyZHMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/clear-page-slider/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93oFX1B3dqhfMeta?.name ?? "collection-slug",
    path: _91_46_46_46slug_93oFX1B3dqhfMeta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_93oFX1B3dqhfMeta || {},
    alias: _91_46_46_46slug_93oFX1B3dqhfMeta?.alias || [],
    redirect: _91_46_46_46slug_93oFX1B3dqhfMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_930BL4GZu2eTMeta?.name ?? "fabriki-slug",
    path: _91_46_46_46slug_930BL4GZu2eTMeta?.path ?? "/fabriki/:slug(.*)*",
    meta: _91_46_46_46slug_930BL4GZu2eTMeta || {},
    alias: _91_46_46_46slug_930BL4GZu2eTMeta?.alias || [],
    redirect: _91_46_46_46slug_930BL4GZu2eTMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/fabriki/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexRPbLw8m6D3Meta?.name ?? "fabriki",
    path: indexRPbLw8m6D3Meta?.path ?? "/fabriki",
    meta: indexRPbLw8m6D3Meta || {},
    alias: indexRPbLw8m6D3Meta?.alias || [],
    redirect: indexRPbLw8m6D3Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/fabriki/index.vue").then(m => m.default || m)
  },
  {
    name: _91hash_93sEyZ0eTGLLMeta?.name ?? "order-status-hash",
    path: _91hash_93sEyZ0eTGLLMeta?.path ?? "/order-status/:hash()",
    meta: _91hash_93sEyZ0eTGLLMeta || {},
    alias: _91hash_93sEyZ0eTGLLMeta?.alias || [],
    redirect: _91hash_93sEyZ0eTGLLMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/order-status/[hash].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93d8UUGL1KoeMeta?.name ?? "product-slug",
    path: _91_46_46_46slug_93d8UUGL1KoeMeta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_93d8UUGL1KoeMeta || {},
    alias: _91_46_46_46slug_93d8UUGL1KoeMeta?.alias || [],
    redirect: _91_46_46_46slug_93d8UUGL1KoeMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexB9CpW7mpixMeta?.name ?? "profile",
    path: indexB9CpW7mpixMeta?.path ?? "/profile",
    meta: indexB9CpW7mpixMeta || {},
    alias: indexB9CpW7mpixMeta?.alias || [],
    redirect: indexB9CpW7mpixMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexcXMe0A11eyMeta?.name ?? "profile-orders",
    path: indexcXMe0A11eyMeta?.path ?? "/profile/orders",
    meta: indexcXMe0A11eyMeta || {},
    alias: indexcXMe0A11eyMeta?.alias || [],
    redirect: indexcXMe0A11eyMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/profile/orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexe6stM6e0hUMeta?.name ?? "recently",
    path: indexe6stM6e0hUMeta?.path ?? "/recently",
    meta: indexe6stM6e0hUMeta || {},
    alias: indexe6stM6e0hUMeta?.alias || [],
    redirect: indexe6stM6e0hUMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/recently/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93MyqoL7Ux4JMeta?.name ?? "sets-slug",
    path: _91_46_46_46slug_93MyqoL7Ux4JMeta?.path ?? "/sets/:slug(.*)*",
    meta: _91_46_46_46slug_93MyqoL7Ux4JMeta || {},
    alias: _91_46_46_46slug_93MyqoL7Ux4JMeta?.alias || [],
    redirect: _91_46_46_46slug_93MyqoL7Ux4JMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/sets/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexqh8e2ecWoVMeta?.name ?? "wishlist",
    path: indexqh8e2ecWoVMeta?.path ?? "/wishlist",
    meta: indexqh8e2ecWoVMeta || {},
    alias: indexqh8e2ecWoVMeta?.alias || [],
    redirect: indexqh8e2ecWoVMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260930074438/pages/wishlist/index.vue").then(m => m.default || m)
  }
]